import { render, staticRenderFns } from "./hotcity.vue?vue&type=template&id=5d441e96"
import script from "./hotcity.vue?vue&type=script&lang=js"
export * from "./hotcity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports